module.exports = __webpack_public_path__ + "static/TT-Plans-Location-f908f37c6d38a811b10fa6c353f6fb09.jpg";